import { render } from "./Paragraph.vue?vue&type=template&id=d06fc0f6"
import script from "./Paragraph.vue?vue&type=script&lang=ts"
export * from "./Paragraph.vue?vue&type=script&lang=ts"

import "./Paragraph.vue?vue&type=style&index=0&id=d06fc0f6&lang=scss"
script.render = render

export default script